import { rootProtectedPath, services } from "data/authData";
import MemoryRounded from "@mui/icons-material/MemoryRounded";
import UploadFileRounded from "@mui/icons-material/UploadFileRounded";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import BookRoundedIcon from "@mui/icons-material/BookRounded";

export const shippingPartnerDrawerElements = {
	shipping_partner_reco: {
		name: "Shipping Partner Reco",
		key: "shipping_partner_reco",
		display: true,
		icon: <LocalShippingOutlinedIcon />,
		types: {
			partner_file_upload: {
				name: "File Uploads",
				key: "file_upload",
				display: true,
				icon: <UploadFileRounded />,
			},
			partner_file_logs: {
				name: "File Logs",
				key: "file_logs",
				display: true,
				icon: <BookRoundedIcon />,
			},
			jobs: {
				name: "Reco Jobs",
				key: "reco_jobs",
				display: true,
				icon: <MemoryRounded />,
			},
			view_common_files: {
				name: "Common Files",
				key: "common_files",
				display: true,
				icon: <UploadFileRounded />,
			},
		},
	},
};
export const sprPartnerFileUploadPath = `${rootProtectedPath}/${services.shipping_partner_reco.path}/${shippingPartnerDrawerElements.shipping_partner_reco.key}/${shippingPartnerDrawerElements.shipping_partner_reco.types.partner_file_upload.key}`;

export const selectOptKeyName = "select_options";
export const shippingPartnerRecoParamName = "tab";

export const allOption = "ALL";

export const allLogicProfilesPath = `${rootProtectedPath}/${services.shipping_partner_reco.path}`;

export const PARTNER_CONFIG = {
	shiprocket: {
		label: "Shiprocket",
		files: [
			{ key: "forward", label: "Forward File" },
			{ key: "reverse", label: "Reverse File" },
		],
	},
	blitz: {
		label: "Blitz",
		files: [{ key: "main", label: "Shipment File" }],
	},
	shadowfax: {
		label: "Shadowfax",
		files: [
			{ key: "forward", label: "Forward File" },
			{ key: "reverse", label: "Reverse File" },
		],
	},
};

// Googe sheet links.
export const RECO_SHEETS = [
	{
		category: "Slabs",
		sheets: [
			{
				name: "Shiprocket Slab",
				description: "Slab sheet for Shiprocket partner",
				key: "SHIPROCKET_SLAB",
				url: "/shipping_partner_reco/",
			},
			{
				name: "Blitz Slab",
				description: "Slab sheet for Blitz partner",
				key: "BLITZ_SLAB",
				url: "/shipping_partner_reco/",
			},
			{
				name: "Shadowfax Forward Slab",
				description: "Slab sheet for Shadowfax partner forward",
				key: "SHADOWFAX_FORWARD_SLAB",
				url: "/shipping_partner_reco/",
			},
			{
				name: "Shadowfax Reverse Slab",
				description: "Slab sheet for Shadowfax partner reverse",
				key: "SHADOWFAX_REVERSE_SLAB",
				url: "/shipping_partner_reco/",
			},
		],
	},
	{
		category: "Category Against Weight",
		sheets: [
			{
				name: "Category vs Weight",
				description: "Weight mapping against respective  category along with quantity",
				key: "CATEGORY_AGAINST_WEIGHT",
				url: "/shipping_partner_reco/",
			},
		],
	},
	{
		category: "Shipment Type",
		sheets: [
			{
				name: "Shipment Type Mapping",
				description: "Shipment type mapping against various courier",
				key: "SHIPPING_TYPE",
				url: "/shipping_partner_reco/",
			},
		],
	},
];
